import type { RundownUnresolvedSelection } from "@southfields-digital/mxmz-resource-model";
import type { Variant } from "src/components/Toast/types";

/** An output may back more than one canvas, under the same name. */
const outputNames = (canvases: RundownCanvas[]): Map<string, string> => {
	const names = new Map<string, string>();

	for (const canvas of canvases) {
		if (canvas.output) names.set(canvas.output.id, canvas.output.name);
	}

	return names;
};

const scope = ({ outputId }: RundownUnresolvedSelection, names: Map<string, string>) => {
	if (outputId === null) return "Sandbox";

	// An id is hex the operator cannot place, so an output we cannot name stays anonymous.
	const name = names.get(outputId);

	return name ? `Output ${name}` : "An output";
};

const describe = (entry: RundownUnresolvedSelection, names: Map<string, string>) => {
	const resource = entry.resourceName ?? entry.resourceId;

	return entry.reason === "unknown-resource"
		? `${scope(entry, names)}: no revision of ${resource} is pinned`
		: `${scope(entry, names)}: ${resource} has no instance "${entry.instanceId}"`;
};

/** A saved selection the pinned revisions cannot supply airs field defaults, so the save says so. */
export const updateRundownNotification = (
	unresolved: RundownUnresolvedSelection[],
	canvases: RundownCanvas[] = [],
): { variant: Variant; title: string; description?: string } => {
	if (!unresolved.length) return { variant: "success", title: "Your rundown has been updated" };

	const names = outputNames(canvases);

	return {
		variant: "warning",
		title: "Rundown updated, but some selected instances are unavailable",
		description: unresolved.map((entry) => describe(entry, names)).join("; "),
	};
};
